/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "LogEvent": {
                    "fields": {
                      "applet": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "feature": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "page": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "target": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "subFeature": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "dynamicProperties": {
                        "type": "string",
                        "id": 6,
                        "keyType": "string"
                      },
                      "action": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent.Action",
                        "id": 7,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Action": {
                        "values": {
                          "CLICK": 0,
                          "VIEW": 1
                        }
                      }
                    }
                  },
                  "ScreenHeader": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "title": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "titleLarge": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "eyebrow": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "style": {
                        "type": ".squareup.bbfrontend.service.v1.ScreenHeader.Style",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": "STYLE_COMPACT"
                        }
                      },
                      "backButton": {
                        "type": ".squareup.bbfrontend.service.v1.ScreenHeader.BackButton",
                        "id": 5,
                        "rule": "optional"
                      },
                      "logEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 6,
                        "rule": "optional"
                      },
                      "paragraph": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "width": {
                        "type": ".squareup.bbfrontend.service.v1.ScreenHeader.Width",
                        "id": 9,
                        "rule": "optional",
                        "options": {
                          "default": "WIDTH_FULL"
                        }
                      }
                    },
                    "nested": {
                      "BackButton": {
                        "fields": {
                          "icon": {
                            "type": ".squareup.bbfrontend.service.v1.ScreenHeader.BackButton.Icon",
                            "id": 1,
                            "rule": "optional"
                          },
                          "logEvent": {
                            "type": ".squareup.bbfrontend.service.v1.LogEvent",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Icon": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "ICON_BACK": 1,
                              "ICON_CANCEL": 2,
                              "ICON_NONE": 3
                            }
                          }
                        }
                      },
                      "Style": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "STYLE_COMPACT": 1,
                          "STYLE_LARGE": 2
                        }
                      },
                      "Width": {
                        "values": {
                          "WIDTH_FULL": 0,
                          "WIDTH_SCREEN_REGULAR": 1,
                          "WIDTH_SCREEN_WIDE": 2
                        }
                      }
                    }
                  },
                  "Toast": {
                    "fields": {
                      "style": {
                        "type": ".squareup.bbfrontend.service.v1.Toast.Style",
                        "id": 1,
                        "rule": "optional"
                      },
                      "text": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "automaticDismissalTimeout": {
                        "type": "double",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": 2000.0
                        }
                      }
                    },
                    "nested": {
                      "Style": {
                        "values": {
                          "INFO": 0,
                          "SUCCESS": 1,
                          "WARNING": 2,
                          "CRITICAL": 3
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.LogEvent && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.LogEvent?.nested?.Action && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenHeader && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenHeader?.nested?.BackButton && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenHeader?.nested?.BackButton?.nested?.Icon && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenHeader?.nested?.Style && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenHeader?.nested?.Width && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Toast && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.Toast?.nested?.Style) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE LogEvent @ squareup/bbfrontend/common/workflow/ui_elements/common.proto at 11:1
 */
export const LogEvent = $root.lookupType('squareup.bbfrontend.service.v1.LogEvent');
fixType(LogEvent, {
  applet: {
    notEmpty: true
  },
  feature: {
    notEmpty: true
  },
  page: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(LogEvent);
/**
 * SOURCE Action @ squareup/bbfrontend/common/workflow/ui_elements/common.proto at 20:3
 */
LogEvent.Action = $root.lookupEnum('squareup.bbfrontend.service.v1.LogEvent.Action').values;
/**
 * ScreenHeader represents the toolbar or navigation for a screen.
 * https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=21451%3A15815
 *
 * SOURCE ScreenHeader @ squareup/bbfrontend/common/workflow/ui_elements/common.proto at 30:1
 */
export const ScreenHeader = $root.lookupType('squareup.bbfrontend.service.v1.ScreenHeader');
fixType(ScreenHeader, {
  id: {
    notEmpty: true
  },
  title: {
    notEmpty: true
  },
  backButton: {
    required: true
  }
});
Builder.createAndAttachToType(ScreenHeader);
/**
 * Defines the left/back navigation button style and logging.
 *
 * SOURCE BackButton @ squareup/bbfrontend/common/workflow/ui_elements/common.proto at 32:3
 */
ScreenHeader.BackButton = $root.lookupType('squareup.bbfrontend.service.v1.ScreenHeader.BackButton');
fixType(ScreenHeader.BackButton, {
  icon: {
    required: true
  }
});
Builder.createAndAttachToType(ScreenHeader.BackButton);
/**
 * SOURCE Icon @ squareup/bbfrontend/common/workflow/ui_elements/common.proto at 33:5
 */
ScreenHeader.BackButton.Icon = $root.lookupEnum('squareup.bbfrontend.service.v1.ScreenHeader.BackButton.Icon').values;
/**
 * Style to render title and eyebrow in the header.
 *
 * SOURCE Style @ squareup/bbfrontend/common/workflow/ui_elements/common.proto at 45:3
 */
ScreenHeader.Style = $root.lookupEnum('squareup.bbfrontend.service.v1.ScreenHeader.Style').values;
/**
 * Width to render the header/navigation item with - matches Market definitions.
 *
 * SOURCE Width @ squareup/bbfrontend/common/workflow/ui_elements/common.proto at 54:3
 */
ScreenHeader.Width = $root.lookupEnum('squareup.bbfrontend.service.v1.ScreenHeader.Width').values;
/**
 * Used to show a toast at the bottom of the screen. Toasts in general are short messages and
 * auto dismissing.
 *
 * SOURCE Toast @ squareup/bbfrontend/common/workflow/ui_elements/common.proto at 85:1
 */
export const Toast = $root.lookupType('squareup.bbfrontend.service.v1.Toast');
fixType(Toast);
Builder.createAndAttachToType(Toast);
/**
 * SOURCE Style @ squareup/bbfrontend/common/workflow/ui_elements/common.proto at 92:3
 */
Toast.Style = $root.lookupEnum('squareup.bbfrontend.service.v1.Toast.Style').values;